import { EXAM_COMMITTIEES, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListExamCommittiees from "./List";
import CreateExamCommittiee from "./Create";
import EditExamCommittiee from "./Edit";
import GroupsIcon from "@mui/icons-material/Groups";
import ShowExamCommittiee from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <GroupsIcon />,
  name: SpecialistServicePath + EXAM_COMMITTIEES,
  title: "Изпитни комисии",
  list: <ListExamCommittiees />,
  show: <ShowExamCommittiee />,
  create: <CreateExamCommittiee />,
  edit: <EditExamCommittiee />,
  permission: permissions.canPreviewSpecialistsExamCommittees,
  showPermission: permissions.canPreviewSpecialistsExamCommittees,
  createPermission: permissions.canCreateSpecialistsExamCommittees,
  editPermission: permissions.canUpdateSpecialistsExamCommitteesInfo,
};
